import React, { createContext, useContext } from 'react';

const CheckoutLocalizationContext = createContext({
  locale: 'en-US',
  timezone: 'UTC',
  country: 'US',
});

export function useCheckoutLocalization() {
  const context = useContext(CheckoutLocalizationContext);
  if (!context) {
    throw new Error('useCheckoutLocalization must be used within a CheckoutLocalizationProvider');
  }
  return context;
}

export function CheckoutLocalizationProvider({ children, localization }) {
  return (
    <CheckoutLocalizationContext.Provider value={localization}>
      {children}
    </CheckoutLocalizationContext.Provider>
  );
}
